import { memo } from "react"

import { Collapsable } from "~/shared/ui/kit"

import { AdditionalInfo, AdditionalInfoProps } from "./AdditionalInfo"
import { type BreadcrumbLinksType, Breadcrumbs } from "./Breadcrumbs"

import cssModule from "./index.module.scss"
import { cx } from "classix"

export type TopbarProps = {
	breadcrumbs: BreadcrumbLinksType
	hide: boolean
	additionalInfo: AdditionalInfoProps["additionalInfo"]
	backUrl: string
}

export const Topbar = memo(function Topbar({
	breadcrumbs,
	hide,
	additionalInfo,
	backUrl,
}: TopbarProps) {
	return (
		<Collapsable open={!hide}>
			<nav className={cx(cssModule.topbar, hide && cssModule.hide)}>
				<Breadcrumbs links={breadcrumbs} backUrl={backUrl} />
				<AdditionalInfo additionalInfo={additionalInfo} />
			</nav>
		</Collapsable>
	)
})
